<div class="modal-header">
  <h3 class="modal-title">
    <strong>Dicas para uma boa foto!</strong>
  </h3>
</div>

<div class="modal-body text-center">
  <p class="mb-32">
    Precisa de ajuda para tirar as melhores fotos? Confira algumas dicas abaixo:
  </p>

  <ul>
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>
        <strong>Não utilize</strong> bonés, chapéus, toucas, óculos ou qualquer
        outro acessório que <strong>limite sua identificação.</strong>
      </p>
    </li>
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>
        Um <strong>ambiente bem iluminado</strong> proporciona fotos melhores.
      </p>
    </li>
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>
        <strong
          >Não é permitido enviar a captura de fotos de outras fotos.</strong
        >
        Precisamos de uma foto real sua para garantirmos confidencialidade e
        segurança.
      </p>
    </li>
  </ul>
</div>

<div class="modal-footer centered">
  <button
    type="button"
    class="btn btn btn-full-orange"
    (click)="closeOnClick()"
  >
    Ok, entendi
  </button>
</div>
